// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1tJGw","item":"PaymentsMobile_item__32tm9","label":"PaymentsMobile_label__3qSB_","amount":"PaymentsMobile_amount__UKJeZ"};